<template>
  <component :is="icon" ref="iconRef" :class="className" />
</template>

<script setup lang="ts">
import {
  computed,
  defineAsyncComponent,
  type DefineComponent,
  type Ref,
  ref,
  watch,
} from "vue";

const props = defineProps({
  /**
   * Required name of the svg file
   */
  name: {
    type: String,
    required: true,
  },
  /**
   * Optional title
   */
  title: {
    type: String,
    default: "",
  },
});

const icon = computed(() =>
  defineAsyncComponent(() => import(`../assets/icons/${props.name}.svg`))
);

const className = computed(() => `svg-icon svg-icon--${props.name}`);

const iconRef: Ref<DefineComponent | null> = ref(null);

// Watch for when icon is loaded.
watch(
  () => iconRef.value,
  (newValue) => {
    if (props.title && newValue?.$el) {
      // Prepend a title tag for accessibility.
      const titleElem = document.createElement("title");
      titleElem.innerText = props.title;
      newValue.$el.prepend(titleElem);
    }
  }
);
</script>

<!--
<style lang="postcss" scoped>
@no-prefix;
.svg-icon {
  @apply tw-w-4 tw-h-4;
  fill: currentColor;
}

.svg-icon--sm {
  @apply tw-w-3 tw-h-3;
}

.svg-icon--lg {
  @apply tw-w-6 tw-h-6;
}

.svg-icon--xl {
  @apply tw-w-12 tw-h-12;
}
@end-no-prefix;
</style>-->
